import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ModerationRates extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId }) {
        if (!organizationId) {
            throw new Error('[ModerationHistory] OrganizationId is mandatory');
        }
        if (!flowId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/rates`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/rates`;
    }

    toOptions() {
        return {
            key: this.id,
            value: this.id,
            text: this.name,
            name: String(this.id)
        };
    }
}
